import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SECTIONS } from '../shared/section';
import { BUSINESS_INFO } from '../shared/data/business.data';

@Component({
  selector: 'lumiron-agb',
  templateUrl: './agb.component.html',
  styleUrl: './agb.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SECTIONS],
})
export class AgbComponent {
  protected readonly business = BUSINESS_INFO;
}
